import { GapAcknowledgment } from '../services/policy-gap-analysis.service';

export const acknowledgmentsMockData: GapAcknowledgment[] = [
  {
    finding_id: 3,
    acknowledged_by: 'security.admin@company.com',
    acknowledged_at: '2025-06-15T14:30:00Z',
    note: 'Access reviews are performed semi-annually per board decision. Quarterly cadence planned for Q1 2026.',
    is_compensating_control: true,
    compensating_control_description:
      'Semi-annual access reviews with automated continuous monitoring via Entra ID alerts for privilege changes.',
  },
  {
    finding_id: 7,
    acknowledged_by: 'ciso@company.com',
    acknowledged_at: '2025-06-10T09:15:00Z',
    note: 'Accepted risk. Network segmentation micro-segmentation project scheduled for Q3 2025.',
    is_compensating_control: false,
    compensating_control_description: null,
  },
];
